import ChangePasswordModal from '../../../components/modal/ChangePasswordModal';
import { Button, Card, Form, Input, Select, TreeSelect } from 'antd';
import { EditLayout } from 'components/layout/layout/EditLayout';
import { IAgent } from 'interfaces/agents';
import { IRole } from 'interfaces/roles';
import { PageHeader } from 'components/professor_area/PageHeader';
import { SettingOutlined } from '@ant-design/icons';
import { isSuperAdmin } from 'services/auth';
import { treePermissions } from 'services/permissions';
import { useForm, useSelect } from '@refinedev/antd';
import { useGetIdentity } from '@refinedev/core';
import { useMemo, useState } from 'react';

export const AgentEdit = () => {
  const { data: user } = useGetIdentity();
  const [modalVisibility, setModalVisibility] = useState(false);
  const { formProps, saveButtonProps, queryResult } = useForm<IAgent>();

  const { selectProps: _roleSelectProps, queryResult: roleQueryResult } =
    useSelect<IRole>({
      resource: 'roles',
      optionLabel: 'name',
      optionValue: 'id',
      defaultValue: queryResult?.data?.data.role_ids,

      pagination: {
        mode: 'client',
        pageSize: 1000
      }
    });

  const roleOptions = useMemo(() => {
    return roleQueryResult?.data?.data.map(role => ({
      label: role.name,
      value: role.id
    }));
  }, [roleQueryResult?.data?.data]);

  const permissions = useMemo(() => {
    if (!queryResult?.data?.data.permissions) {
      return [];
    }

    return queryResult?.data?.data.permissions;
  }, [queryResult?.data?.data.permissions]);

  return (
    <EditLayout title="Editar usuário" saveButtonProps={saveButtonProps}>
      <PageHeader
        title={formProps.initialValues?.name}
        icon={SettingOutlined}
        actions={
          isSuperAdmin(user as IAgent) && (
            <Button
              type="primary"
              onClick={() => setModalVisibility(true)}
              style={{ width: 110 }}
            >
              Alterar Senha
            </Button>
          )
        }
      />
      <Card>
        <Form {...formProps} layout="vertical">
          <Form.Item
            label="Nome"
            name="name"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Login"
            name="login"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item label="Grupos" name="role_ids">
            <Select
              mode="multiple"
              options={roleOptions}
              optionFilterProp="label"
            />
          </Form.Item>

          <Form.Item label="Permissões" name="permissions">
            <TreeSelect
              treeData={treePermissions(permissions)}
              treeCheckable={true}
              showCheckedStrategy={TreeSelect.SHOW_PARENT}
            />
          </Form.Item>
        </Form>
      </Card>
      <ChangePasswordModal
        agentId={formProps.initialValues?.id}
        requireCurrentPassword={false}
        modalVisibility={modalVisibility}
        changeVisibility={setModalVisibility}
      />
    </EditLayout>
  );
};
